import { Box, COLORS, createComponentWrapperWithRef, styled } from '@msdk/ui'
import { uiTokens } from '@msdk/ui'
import { Typography } from '@mui/material'

interface Props {
  children?: React.ReactNode
  title: string
  type?: 'products' | 'services' | undefined
}

const StyledAboutViewMuiContainer = styled(Box)`
  background-color: ${COLORS.white.main};
  border-radius: 6px;
  border: 1px solid ${COLORS.divider};
`
const StyledAboutViewNovaContainer = styled(Box)`
  background-color: ${uiTokens.uiSurface.interactive};
  border-radius: ${uiTokens.radius.large}px;
  border: ${uiTokens.sizing.stroke.light}px solid ${uiTokens.uiStroke.neutral};
`

const StyledAboutViewContainer = createComponentWrapperWithRef(
  {
    mui: StyledAboutViewMuiContainer,
    nova: StyledAboutViewNovaContainer,
  },
  'StyledAboutViewContainer',
)

const StyledAboutViewMuiTitleContainer = styled(Box)`
  padding: 16px 24px;
  border-bottom: 1px solid ${COLORS.divider};
  height: 57px;
`
const StyledAboutViewNovaTitleContainer = styled(Box)`
  padding: 0 ${uiTokens.spacing.padding.medium}px;
  border-bottom: ${uiTokens.sizing.stroke.medium}px solid ${uiTokens.uiStroke.neutral};
  align-items: center;
  align-self: stretch;
  gap: 16px;
  display: flex;
  height: ${uiTokens.sizing.dataGrid.height.header.standard}px;
`
const StyledAboutViewTitleContainer = createComponentWrapperWithRef(
  {
    mui: StyledAboutViewMuiTitleContainer,
    nova: StyledAboutViewNovaTitleContainer,
  },
  'StyledAboutViewTitleContainer',
)

const StyledAboutViewMuiTitleTypography = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
`
const StyledAboutViewNovaTitleTypography = styled(Typography)<{ $type?: 'products' | 'services' | undefined }>`
  font-weight: ${uiTokens.font.fontWeight.semiBold};
  font-family: ${uiTokens.font.fontFamily.default};
  color: ${uiTokens.uiContent.neutral};
  line-height: ${({ $type }) =>
    `${$type === 'products' ? uiTokens.font.lineHeight.heading.h6 : uiTokens.font.lineHeight.dataGrid.header}px`};
  font-size: ${({ $type }) =>
    `${$type === 'products' ? uiTokens.font.fontSize.heading.h6 : uiTokens.font.fontSize.dataGrid.header}px`};
`
const StyledAboutViewTitleTypography = createComponentWrapperWithRef<{
  children: React.ReactNode
  type: 'products' | 'services' | undefined
}>(
  {
    mui: StyledAboutViewMuiTitleTypography,
    nova: ({ children, type }) => (
      <StyledAboutViewNovaTitleTypography $type={type} variant="h6">
        {children}
      </StyledAboutViewNovaTitleTypography>
    ),
  },
  'StyledAboutViewTitleTypography',
)

const StyledAboutViewMuiContent = styled(Box)`
  padding: 16px 24px;
`
const StyledAboutViewNovaContent = styled(Box)`
  padding: 0;
`

const StyledAboutViewContent = createComponentWrapperWithRef(
  {
    mui: StyledAboutViewMuiContent,
    nova: StyledAboutViewNovaContent,
  },
  'StyledAboutViewContent',
)

const AboutCustomView = (props: Props) => {
  return (
    <StyledAboutViewContainer>
      <StyledAboutViewTitleContainer>
        <StyledAboutViewTitleTypography type={props.type}>{props.title}</StyledAboutViewTitleTypography>
      </StyledAboutViewTitleContainer>
      <StyledAboutViewContent>{props.children}</StyledAboutViewContent>
    </StyledAboutViewContainer>
  )
}

export default AboutCustomView
